// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactScreenVideoLayout__video-layout-cb94e5 {
  display: grid;
  gap: 8px;
  padding: 0 8px;
  overflow: auto;
}

.CompactScreenVideoLayout__video-layout-1-d0c1c1 {
  grid-template-rows: 1fr;
}

.CompactScreenVideoLayout__video-layout-2-f9bf43 {
  grid-template-rows: 1fr 1fr;
}

.CompactScreenVideoLayout__video-layout-3-f01985 {
  grid-template-rows: 1fr 1fr 1fr;
}

.CompactScreenVideoLayout__video-layout-4-a2fea9 {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

.CompactScreenVideoLayout__video-layout-5-c9749b {
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: ". ." ". ." "last last";
}

.CompactScreenVideoLayout__video-layout-5-c9749b > div:last-child {
  grid-area: last;
}

.CompactScreenVideoLayout__video-layout-full-grid-d4d658 {
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(31%, 1fr);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/CompactScreenVideoLayout/CompactScreenVideoLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,+BAAA;EACA,8BAAA;EACA,4CAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,8BAAA;EACA,gCAAA;AACF","sourcesContent":[".video-layout {\n  display: grid;\n  gap: 8px;\n  padding: 0 8px;\n  overflow: auto;\n}\n\n.video-layout-1 {\n  grid-template-rows: 1fr;\n}\n\n.video-layout-2 {\n  grid-template-rows: 1fr 1fr;\n}\n\n.video-layout-3 {\n  grid-template-rows: 1fr 1fr 1fr;\n}\n\n.video-layout-4 {\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n\n.video-layout-5 {\n  grid-template-rows: 1fr 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas: '. .' '. .' 'last last';\n}\n\n.video-layout-5 > div:last-child {\n  grid-area: last;\n}\n\n.video-layout-full-grid {\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: minmax(31%, 1fr);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-layout": `CompactScreenVideoLayout__video-layout-cb94e5`,
	"videoLayout": `CompactScreenVideoLayout__video-layout-cb94e5`,
	"video-layout-1": `CompactScreenVideoLayout__video-layout-1-d0c1c1`,
	"videoLayout1": `CompactScreenVideoLayout__video-layout-1-d0c1c1`,
	"video-layout-2": `CompactScreenVideoLayout__video-layout-2-f9bf43`,
	"videoLayout2": `CompactScreenVideoLayout__video-layout-2-f9bf43`,
	"video-layout-3": `CompactScreenVideoLayout__video-layout-3-f01985`,
	"videoLayout3": `CompactScreenVideoLayout__video-layout-3-f01985`,
	"video-layout-4": `CompactScreenVideoLayout__video-layout-4-a2fea9`,
	"videoLayout4": `CompactScreenVideoLayout__video-layout-4-a2fea9`,
	"video-layout-5": `CompactScreenVideoLayout__video-layout-5-c9749b`,
	"videoLayout5": `CompactScreenVideoLayout__video-layout-5-c9749b`,
	"video-layout-full-grid": `CompactScreenVideoLayout__video-layout-full-grid-d4d658`,
	"videoLayoutFullGrid": `CompactScreenVideoLayout__video-layout-full-grid-d4d658`
};
module.exports = ___CSS_LOADER_EXPORT___;
